<template>
  <div class="header" :style="{ 'background': colors }">
    <div class="men_infortop mui-clearfix">
      <!-- <div @click="statistics_fn('lefticon', '/')" class="logo"><img src="../assets/images/logos.png"/></div> -->
      <!-- <a :href="getCursor+'career/index.html'" class="logo measurement_public"><img src="../assets/images/logos.png"/></a> -->
      <router-link :to="{path:'/index',query:{'pdk':routArg.pdk,'aspx':routArg.aspx,'source':routArg.source}}"  class="logo measurement_public"><img src="../../assets/images/logos.png"/></router-link>
      <router-link  :to="{path:'/person',query:{'pdk':routArg.pdk,'aspx':routArg.aspx,'source':routArg.source}}" class="per_img"><img :src="headimg"/></router-link>
      <!-- <a :href="getCursor + 'career/person/person.html'" class="per_img"><img :src="headimg"/></a> -->
    </div>
  </div>
</template>
<script>
import { statistics } from "@/api/public";
import { getCursorHash } from "@/utils/tools";
export default {
  data() {
    return {
      getCursor: ""
    }
  },
  props: {
    colors: {
      type: String,
      default: ""
    },
    headimg: {
      type: String,
      default: ""
    },
    routArg: {
      type: Object,
      default: {}
    }
  },
  methods: {
    statistics_fn(type, path){
      statistics({
        type: type
      })
      .then((data) => {
        this.$router.push(path);
      })
    }
  },
  created() {
      this.getCursor = getCursorHash()
    }
}
</script>
<style lang="scss" scoped>
	@import "@s/remChange.scss";
	.men_infortop {
    line-height: 1;
    padding: changeRem(0.4)+px changeRem(0.6)+px;
  }
  .men_infortop {
    color: #EB5032;
    font-size: changeRem(0.68)+px;
    text-align: left;
    .logo{
      display: inline-block;
      width: changeRem(4.8)+px;
    }
    .per_img{
      display: inline-block;
      float: right;
      width: changeRem(1.2)+px;
      img{
        border-radius: 50%;
      }
    }
    img{
      width: 100%;
    }
  }
</style>